import * as React from "react";
import { Button } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { cloneDeep, get } from "lodash";
import { ArrayString } from "../../schema/types/org/input";
import { store } from "../../store";
import { formSet, formSetValue, formTriggerValidation, useCpFormValue } from "../gvc/testNewForm/utils";
import { FormListFieldItem } from "../gvc/formListFieldItem";
import { CpAutoComplete } from "../gvc/testNewForm/CpAutoComplete";
import { useCpFormContext } from "../../components/form/useCpFormContext";

interface Props {
  name?: string;
  item?: ArrayString;
  index?: number;
}
export const CpArrayItemOrgInvitee: React.FC<Props> = React.memo(({ name: _name, item: _item, index: _index }) => {
  const { id } = useCpFormContext();

  const name = _name!;
  const item = _item!;
  const index = _index!;

  function remove() {
    const form = store.getState().form.instances[id];
    const values = form.values;
    const items = get(values, name) || [];
    let _items = cloneDeep(items);
    _items = _items.filter((i) => i.id !== item.id);
    formSetValue(id, name, _items);

    formTriggerValidation(id);
  }

  const users = useCpFormValue(`meta.users`);
  const invitees = useCpFormValue(`invitees`);
  const inviteeOptions = users.filter((user) => {
    if (invitees.some((i) => i.value === user.email)) {
      return false;
    }
    return true;
  });

  return (
    <FormListFieldItem columnCount={1} hasRemoveButton className="mb-1">
      <CpAutoComplete
        name={`${name}.${index}.value`}
        options={inviteeOptions.map((i) => ({ label: i.email, value: i.email }))}
      />
      <Button type={`text`} danger icon={<MinusCircleOutlined />} onClick={() => remove()} />
    </FormListFieldItem>
  );
});
